module.exports = __webpack_public_path__ + "70279ac16af0cec2d349d318be3805fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/survey-activity.png
// module id = 482
// module chunks = 0